"use client";

import { cn } from "@/lib/utils";
import Image from "next/image";
import { PortableText } from "@portabletext/react";
import { richTextComponent } from "@/sanity/sanityPortableText";
import { PageChallengeSchema } from "@/sanity/pages/PageChallengeTemplate";
import ChipSerif from "@/components/global/ui/ChipSerif";
import checkbox from "@/public/challenge/checkbox.svg";
import { motion } from "framer-motion";

import { PortableTextBlock } from "sanity";
import FAQListNew from "@/components/global/ui/FAQListNew";

export default function FaqNewSection({
  // data,
  className,
  chip,
  title,
  faqList,
}: {
  // data: PageChallengeSchema;
  chip: string;
  title: PortableTextBlock[];
  faqList: {
    question: string;
    answer: PortableTextBlock[];
  }[];
  className?: string;
}) {
  return (
    <section
      className={cn("relative overflow-clip px-[2rem] lg:px-0", className)}
    >
      <div className="w-[min(119.875rem,100%)] mx-auto flex flex-col items-start lg:items-center py-[4.5rem] lg:py-[11.25rem] relative lg:bg-[#FCFDFD] lg:border lg:border-[#E5E5E580] rounded-[4rem] lg:px-[2rem]">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
        >
          <ChipSerif text={chip} />
        </motion.div>

        {title && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
            className="richtext richtext-start lg:richtext-center lg:[&_br]:hidden"
          >
            <PortableText value={title} components={richTextComponent} />
          </motion.div>
        )}

        <FAQListNew
          faq={faqList}
          className="mt-[3rem] lg:mt-[6rem] w-[min(89.375rem,100%)]"
        />
      </div>
    </section>
  );
}
